// extracted by mini-css-extract-plugin
module.exports = {"warning":"Alert_warning__3H2g8","success":"Alert_success__-MVQ4"};